<template>
	<div vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
			<div class="vx-row">
				<div class="vx-col sm:w-1/4 w-full mb-2">
					<vs-input  :disabled="estado_numero_identificacion"
						v-validate="'min:10|max:15'"
						type="number"
						label-placeholder="Name"
						name="numero_identificacion"
						data-vv-as="número de identificación"
						placeholder="Cédula de Identidad*"
						v-model="numero_identificacion"
						class=" w-full  mt-6 input-border" />
				</div>
				<div class="mt-6 flex flex-nowrap">
					<vs-button color="success" type="filled" icon="search" @click="searchIdentificationNumber" title="Buscar persona" class="mr-1"></vs-button>
					<vs-button color="rgb(251, 114, 138)" type="filled" icon="backspace" @click="clearForm" title="Limpiar"></vs-button>
				</div>
				
			</div>
			<div class="vx-row">
				<div class="vx-col sm:w-1/2 w-full mb-2">
					<vs-input :disabled="estado_email"
						v-validate="'required|email'"
						data-vv-validate-on="blur"
						name="email"
						type="email"
						label-placeholder="Email"
						placeholder="Email*"
						v-model="email"
						class="w-full  mt-6 input-border" />
				<span class="text-danger text-sm">{{ errors.first('email') }}</span>
				</div>
				<div class="vx-col sm:w-1/4 w-full mb-2">
					<vs-input :disabled="estado_contrasenia"
						ref="password"
						type="password"
						data-vv-validate-on="blur"
						v-validate="'required|min:6|max:30'"
						data-vv-as="contraseña"
						name="contrasenia"
						label-placeholder="Contraseña"
						placeholder="Contraseña*"
						v-model="contrasenia"
						class="w-full  mt-6 input-border" />
					<span class="text-danger text-sm">{{ errors.first('contrasenia') }}</span>
				</div>
				<div class="vx-col sm:w-1/4 w-full mb-2">
					<vs-input :disabled="estado_confirm_contrasenia"
						type="password"
						v-validate="'min:6|max:30|confirmed:password'"
						data-vv-validate-on="blur"
						data-vv-as="confirmación de contraseña"
						name="confirm_contraseniad"
						label-placeholder="Confirmar Contraseña"
						placeholder="Confirmar Contraseña*"
						v-model="confirm_contrasenia"
					class="w-full  mt-6 input-border" />
					<span class="text-danger text-sm">{{ errors.first('confirm_contrasenia') }}</span>
					<span class="text-danger text-sm" v-show="igualdad_contrasenia">  No son iguales las contraseñas.</span>
					
				</div>

				<div class="vx-col  sm:w-1/2 w-full mb-5">
					<vs-input :disabled="estado_nombres"
					v-validate="'required|min:3'"
					data-vv-validate-on="blur"
					label-placeholder="Nombre"
					name="nombres"
					placeholder="Nombres*"
					v-model="nombres"
					class=" w-full  mt-6 input-border" />
					<span class="text-danger text-sm">{{ errors.first('nombres') }}</span>
				</div>

				<div class="vx-col sm:w-1/2 w-full mb-2">
					<vs-input :disabled="estado_apellidos"
						data-vv-validate-on="blur"
						label-placeholder="apellidos"
						name="apellidos"
						placeholder="Apellidos*"
						v-model="apellidos"
						class="w-full   mt-6 input-border" />
					<span class="text-danger text-sm">{{ errors.first('apellidos') }}</span>
				</div>
				<div class="vx-col sm:w-1/4 w-full mb-2">
					<vs-input :disabled="estado_telefono"
							type="number"
							v-validate="'max:14'"
							data-vv-validate-on="blur"
							label-placeholder="telefono"
							name="telefono"
							placeholder="Telefono*"
							v-model="telefono"
							:danger="numero_identificacion != '' ? !validateTelefono : false "
							danger-text="Telefono es requerido"
							class=" w-full mt-6 input-border" />
					<span class="text-danger text-sm">{{ errors.first('telefono') }}</span>
				</div>
				
				<div class="vx-col sm:w-1/4 w-full mb-2">
					<vs-input :disabled="estado_celular"
							type="number"
							v-validate="'max:14'"
							data-vv-validate-on="blur"
							label-placeholder="celular"
							name="celular"
							placeholder="Celular"
							v-model="celular"
							class=" w-full  mt-6 input-border" />
					<span class="text-danger text-sm">{{ errors.first('celular') }}</span>
				</div>

				<div class="vx-col sm:w-2/2 w-full mb-2">
					<vs-input :disabled="estado_direccion"
						v-validate="'required|min:3'"
						data-vv-validate-on="blur"
						label-placeholder="direccion"
						name="direccion"
						placeholder="Dirección*"
						v-model="direccion"
						class=" w-full mt-6 input-border" />
						<span class="text-danger text-sm">{{ errors.first('direccion') }}</span>
				</div>
				<div class="vx-col sm:w-2/2 w-full mb-2">
					<vs-input :disabled="estado_referencia"
						data-vv-validate-on="blur"
						label-placeholder="referencia"
						name="referencia"
						placeholder="Referencia"
						v-model="referencia"
						class="  w-full mt-6 input-border" />
				</div>
				<div class="vx-col sm:w-1/4 w-full mb-2">
					<v-select :disabled="estado_pais" placeholder="Seleccione un País*" label="descripcion" key="valor" :options="selects.paises" v-on:input="changePais" v-model="pais"></v-select>
					<span class="text-danger text-sm">{{ errors.first('pais') }}</span>
				</div>
				<div class="vx-col sm:w-1/4 w-full mb-2">
					<v-select :disabled="estado_provincia"  placeholder="Seleccione un Provincia*" label="descripcion" key="valor" :options="selects.provincias" v-on:input="changeProvincia" v-model="provincia"></v-select>
					<span class="text-danger text-sm">{{ errors.first('provincia') }}</span>
				</div>
				<div class="vx-col sm:w-1/4 w-full mb-2">
					<v-select :disabled="estado_canton"  placeholder="Seleccione un Cantón*" label="descripcion" key="valor" :options="selects.ciudades" v-on:input="changeCiudad" v-model="canton"></v-select>
					<span class="text-danger text-sm">{{ errors.first('canton') }}</span>
				</div>
				<div class="vx-col sm:w-1/4 w-full mb-2">
					<v-select :disabled="estado_parroquia" placeholder="Seleccione un Parroquía*" label="descripcion" key="valor" :options="selects.barrios" v-model="parroquia"></v-select>
				</div>
				<div class="vx-col sm:w-2/2 w-full mb-2" style="float:right">
					<!--vs-button type="border" to="/account/login" class="mt-6">Login</vs-button-->
					<vs-button class="float-right mt-6"  @click="registerUserJWt" :disabled="!validateForm">Registrarme</vs-button>
				</div>
			</div>
        </vs-col>

		<vs-popup class="holamundo" title="Mapgrafi informa" :active.sync="popupMensaje">
			<p>{{ mensaje }}
				<br>
			</p>
			<div class="flex flex-wrap text-center mb-3">
				<vs-button  color="primary"  @click="(popupMensaje = !popupMensaje)">Aceptar</vs-button>
			</div>
		</vs-popup>
	</div> 
</template>

<script>

export default {
    data() {
        return {
			estado_numero_identificacion:false,
			estado_contrasenia:true,
			estado_nombres:true,
			estado_apellidos:true,
			estado_nombres:true,
			estado_apellidos:true,
			estado_email:true,
            estado_confirm_contrasenia:true,
			estado_nombres:true,
			estado_apellidos:true,
			estado_telefono:true,
			estado_celular:true,
			estado_direccion:true,
			estado_referencia:true,
			estado_pais:true,
			estado_provincia:true,
			estado_canton:true,
			estado_parroquia:true,
            email: '',
            contrasenia: '',
            confirm_contrasenia: '',
			nombres:'',
			apellidos:'',
			numero_identificacion:'',
			telefono:'',
			celular:'',
			direccion:'',
			referencia:'',
			pais:{descripcion:'',valor:''},
			provincia:{descripcion:'',valor:''},
			canton:{descripcion:'',valor:''},
			parroquia:{descripcion:'',valor:''},
			cod_persona:'',
			id_usuario:'',
			popupMensaje : false,
			mensaje : '',
			form:{
				nombre:"",
				id_pais:"",
				id_provincia:"",
				id_ciudad:"",
				id_barrio:"",
			},
			states:{},
			selects:{
				paises: [],
				provincias:[],
				ciudades:[],
				barrios:[]
			},
        }
	},
    computed: {
		igualdad_contrasenia(){
			var contrasenia = this.contrasenia;
			var confirm_contrasenia = this.confirm_contrasenia;
			if(contrasenia != '' && confirm_contrasenia != '' &&  contrasenia != ' ' && confirm_contrasenia != ' '){
				if(contrasenia !== confirm_contrasenia){
					return true 
				}else{
					return false
				}
			}
			return false;
		},
        validateForm() {
			return ((_.size(this.pais.descripcion) > 0) ? true : false ) && ((_.size(this.provincia.descripcion) > 0) ? true : false ) && ((_.size(this.canton.descripcion) > 0) ? true : false ) && ((_.size(this.parroquia.descripcion) > 0) ? true : false ) && this.direccion != '' && this.email != '' && this.contrasenia != '' && this.confirm_contrasenia != '' && this.nombres != '' && this.apellidos != '' && this.numero_identificacion != '' && (this.telefono !== null && this.telefono !== ''); 
			// !this.errors.any() &&
			// this.nombres != ''	&& 
			// this.apellidos != ''	&&
			// this.numero_identificacion != ''	&&
			// (_.isEmpty(this.pais)	== true ) ? false : true &&     
			// (_.isEmpty(this.provincia)	== true ) ? false : true &&     
			// (_.isEmpty(this.canton)	== true ) ? false : true &&    
			// (_.isEmpty(this.parroquia)	== true ) ? false : true &&    
			// this.direccion != '' && this.email != '' && this.contrasenia != '' && this.confirm_contrasenia != '' ;
        },
		validateTelefono(){
			return this.telefono !== '' && this.telefono !== null;
		}
    },
    methods: {
		paisesRest(clean=true){
			if(clean)this.form.id_pais="";
			var q="paises";
			this.$vs.loading();
			return this.$http.get(this.$store.state.domain+`mapgrafi/division-geografica/paises`)
			.then((response) => {
				this.$vs.loading.close(); 
				this.selects[q] = response.data.data;
				return this.changePais(clean);

			})
			.catch((error)=>{
				this.$vs.loading.close(); 
			});
		},
		provinciasRest(clean=true){
			if(clean)this.form.id_pais="";
			var q="provincias";
			if(_.size(this.pais.descripcion))
			return this.$http.get(this.$store.state.domain+`mapgrafi/division-geografica/pais/${this.pais.valor}/provincias`)
					.then((response) => {
						this.$vs.loading.close(); 
						this.selects[q] = response.data.data;
						return this.changeProvincia(clean);
					})
					.catch((error)=>{
						this.$vs.loading.close(); 
						
					});
		},
		ciudadesRest(clean=true){
			if(clean){
				this.form.id_ciudad="";
				this.form.id_barrio="";
			}
			var q="ciudades";
			if(_.size(this.pais.descripcion) && _.size(this.provincia.descripcion))
			return this.$http.get(this.$store.state.domain+`mapgrafi/division-geografica/pais/${this.pais.valor}/provincia/${this.provincia.valor}/cantones`)
					.then((response) => {
						this.$vs.loading.close(); 
						this.selects[q] = response.data.data;
						return this.changeCiudad(clean);
					})
					.catch((error)=>{
						this.$vs.loading.close(); 
					});
		},
		barriosRest(clean=true){
			if(clean)this.form.id_barrio="";
			var q="barrios";
			if((_.size(this.pais.descripcion) && _.size(this.provincia.descripcion)&& _.size(this.canton.descripcion)))
			return this.$http.get(this.$store.state.domain+`mapgrafi/division-geografica/pais/${this.pais.valor}/provincia/${this.provincia.valor}/canton/${this.canton.valor}/parroquias`)
					.then((response) => {
						this.$vs.loading.close(); 
						this.selects[q] = response.data.data;
					})
					.catch((error)=>{
						this.$vs.loading.close(); 
					});
		},
		changePais(clean=true){
			if(_.isEmpty(this.pais)){
				this.provincia={descripcion:'',valor:''};
				this.canton={descripcion:'',valor:''};
				this.pais={descripcion:'',valor:''};
				this.parroquia={descripcion:'',valor:''};
				this.selects.provincias=[];
				this.selects.barrios=[];
				this.selects.ciudades=[];
			}else{
				return Promise.all([
					this.provinciasRest(clean)
				]).then((values)=>{

				});
			}
		},
		changeProvincia(clean=true){
			if(_.isEmpty(this.provincia)){
				this.provincia={descripcion:'',valor:''};
				this.canton={descripcion:'',valor:''};
				this.parroquia={descripcion:'',valor:''};
				this.selects.ciudades=[];
				this.selects.barrios=[];	
			}else{
				return Promise.all([
				this.ciudadesRest(clean)
				]).then((values)=>{
				});
			}
		},
		changeCiudad(clean=true){
			if(_.isEmpty(this.canton)){
				this.canton={descripcion:'',valor:''};
				this.parroquia={descripcion:'',valor:''};
				this.selects.barrios=[];
			}else{
				return Promise.all([
					this.barriosRest(clean)
				]).then((values)=>{
				});
			}
		},
		blockInput(){
			this.estado_contrasenia=true;
			this.estado_email=true;
            this.estado_confirm_contrasenia=true;
			this.estado_nombres=true;
			this.estado_apellidos=true;
			this.estado_telefono=true;
			this.estado_celular=true;
			this.estado_direccion=true;
			this.estado_referencia=true;
			this.estado_pais=true;
			this.estado_provincia=true;
			this.estado_canton=true;
			this.estado_parroquia=true;
		},
		desBlockInput(){
			this.estado_contrasenia=false;
			this.estado_email=false;
            this.estado_confirm_contrasenia=false;
			this.estado_telefono=false;
			this.estado_celular=false;
			this.estado_direccion=false;
			this.estado_referencia=false;
			this.estado_pais=false;
			this.estado_provincia=false;
			this.estado_canton=false;
			this.estado_parroquia=false;
		},
		clearForm(){
			this.blockInput();
			this.estado_numero_identificacion =	false;
            this.email= '';
            this.contrasenia= '';
            this.confirm_contrasenia= '';
			this.nombres='';
			this.apellidos='';
			this.numero_identificacion='';
			this.telefono='';
			this.celular='';
			this.direccion='';
			this.referencia='';
			this.pais={descripcion:'',valor:''};
			this.provincia={descripcion:'',valor:''};
			this.canton={descripcion:'',valor:''};
			this.parroquia={descripcion:'',valor:''};
			this.cod_persona='';
			this.id_usuario='';
			this.selects.provincias=[];
			this.selects.ciudades=[];
			this.selects.barrios=[];
		},
		searchIdentificationNumber(){
			if(_.size(this.numero_identificacion) != 0){
				this.$vs.loading();
				this.$http.post(this.$store.state.domain+`mapgrafi/seguridad/usuario-consulta`,{
							evento:"L1",
							numero_identificacion: (this.numero_identificacion),
							cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP
				})
				.then((response) => {
					this.$vs.loading.close(); 
					if(response.status != 200) throw 'SERVIDOR NO RESPONDE';
					else if (response.data.existeError){
						this.mensaje = response.data.mensaje;
                        this.popupMensaje = true;
					} 
					else{
						this.estado_numero_identificacion =	true;
						if(_.size(response.data.data) == 0 || response.data.data == null ) {
							this.mensaje = response.data.mensaje;
                            this.popupMensaje = true;
						}
						else{
							this.desBlockInput();
							this.insertDataConsult(response.data.data);
						} 
					}  
				})
			}else{
				this.mensaje = 'Ingrese número de Identificación';
                this.popupMensaje = true;
			}
		},
		insertDataConsult(user){
           	this.email        		   = user.email;
            this.nombres			   = user.nombres;
			this.apellidos             = user.apellidos;
			this.numero_identificacion = user.numero_identificacion;
			this.telefono              = user.telefono;
			this.celular               = user.celular;
			this.direccion             = user.direccion;
			this.referencia            = user.referencia;
			this.pais.descripcion      = (user.pais	== '' ) ? null : user.pais;
			this.provincia.descripcion = (user.provincia	== '' ) ? null : user.provincia;
			this.canton.descripcion    = (user.canton	== '' ) ? null : user.canton;
			this.parroquia.descripcion = (user.parroquia	== '' ) ? null : user.parroquia;
			this.cod_persona		   = user.cod_persona;
			this.pais.valor	           = (user.cod_pais	== 0 )	? null	: user.cod_pais;
			this.provincia.valor	   = (user.cod_provincia == 0 )	? null : user.cod_provincia;
			this.canton.valor	       = (user.cod_canton == 0 )	? null : user.cod_canton;
			this.parroquia.valor	   = (user.cod_parroquia == 0 )	? null : user.cod_parroquia;
			this.changePais(false);

		},
        checkLogin() {
          // If user is already logged in notify
          if(this.$store.state.auth.isUserLoggedIn()) {

            // Close animation if passed as payload
            // this.$vs.loading.close()

            this.$vs.notify({
              title: 'Login Attempt',
              text: 'You are already logged in!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })

            return false
          }
          return true
        },
        registerUserJWt() {
            // If form is not validated or user is already login return
            if (!this.validateForm || !this.checkLogin()) return

            const payload = {
              userDetails: {
				email                : this.email,
				contrasenia          : this.contrasenia,
				confirm_contrasenia  : this.confirm_contrasenia,
				nombres              : this.nombres,
				apellidos            : this.apellidos,
				numero_identificacion: this.numero_identificacion,
				telefono             : this.telefono,
				celular              : this.celular,
				direccion            : this.direccion,
				referencia           : this.referencia,
				pais                 : this.pais.descripcion,
				provincia            : this.provincia.descripcion,
				canton               : this.canton.descripcion,
				parroquia            : this.parroquia.descripcion,
				id_pais              : this.pais.valor,
				id_provincia         : this.provincia.valor,
				id_canton            : this.canton.valor,
				id_parroquia         : this.parroquia.valor,
				cod_persona          : this.cod_persona,
              },
              notify: this.$vs.notify
            }
			this.$vs.loading();
			// PROCESO DE CREACION DE CUENTA 
            this.$store.dispatch('auth/registerUserJWT', payload)
			.then((response)=>{
				this.$vs.loading.close(); 
				this.mensaje = response.data.mensaje;
				this.popupMensaje = true;
				this.clearForm();
			})
	        .catch(error => { 
				this.$vs.loading.close(); 
				this.mensaje = error;
				this.popupMensaje = true;
			});
        },
	},
	created(){
		return Promise.all([ this.paisesRest()])
		.then((values)=>{
		})
	}
}
</script>
